import React, { useState, useRef, useEffect } from "react";
import "./ChiefDashbord.css";
import axios from "axios";
import moment from "jalali-moment";
import ChiefDashbord_sidebar from "../sidebar/ChiefDashbord_sidebar";
import { BiLogOut, BiTrash } from "react-icons/bi";
import { RiSearch2Line } from "react-icons/ri";
import { BsPlusSquare } from "react-icons/bs";
import ChiefDashbord_filters from "./ChiefDashbord_filters/ChiefDashbord_filters";
import DropDown2 from "../../../Components/DropDown2/DropDown2";
import CheckBox from "../../../Components/CheckBox/CheckBox";
import ProfileImage from "../../../user.png";
import ChiefDashbord_Chart from "./ChiefDashbord_Chart";
import ChiefDashbord_Text from "./ChiefDashbord_Text";
import BlogBox from "../../../Components/BlogBox/BlogBox";
import { HiMenu } from "react-icons/hi";
import PersonBox from "../../../Components/PersonBox/PersonBox";
import Drawer from "@mui/material/Drawer";
import useDocumentTitle from "../../../Components/TitleSetter/useDocumentTitle";
import ChiefDashbord_sidebar_res from "../sidebar/ChiefDashbord_sidebar_res";

function ChiefDashbord() {
    useDocumentTitle("باهم | داشبورد مدیریتی | پیشخوان");
    const [DP_DrawerB, setDP_DrawerB] = useState(false);
    const [blogPosts, setBlogPosts] = useState([]);

    let blog = [
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "جدید",
            paid: "نقدی",
        },
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "در حال ارزیابی",
            paid: "نقدی",
        },
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "ارجاع شده",
            paid: "نقدی",
        },
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "تکمیل شده",
            paid: "نقدی",
        },
    ];

    const [postFilter, setPostFilter] = useState(1);

    const optionsList1 = [
        { label: "املاک", value: "املاک" },
        { label: "بازاریاب", value: "بازاریاب" },
        { label: "باهم", value: "باهم" },
        { label: "مستقیم", value: "مستقیم" },
    ];
    const header = useRef(null);
    useEffect(() => {
        header.current.scrollIntoView({ behavior: "smooth" });
    }, []);

    useEffect(() => {
        axios
            .get("https://hammaskan.ir:8443/api/posts", {
                params: {
                    perPage: 6,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                console.log(moment(res.data.data[0].updatedAt).locale("fa").format("YYYY/MM/DD"));
                // console.log(moment(res.data.data[0].updatedAt).fromNow())
                setBlogPosts(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);

    return (
        <div className="ChiefDashbord" ref={header}>
            <div className="ChiefDashbord_SidebarContainer">
                <ChiefDashbord_sidebar ChiefName="کاربر مدیر ارشد" path="" userProfile={ProfileImage} sidebar={2} />
            </div>

            <div className="ChiefDashbord_Feed">
                <div className="ChiefDashbord_FeedHeader">
                    <div className="ChiefDashbord_FeedHeaderTitleContainer">
                        <div className="ChiefDashbord_sideBarOpenIconContainer" onClick={() => setDP_DrawerB(true)}>
                            <HiMenu className="ChiefDashbord_sideBarOpenIcon" />
                        </div>
                        <div className="ChiefDashbord_FeedHeaderTitleBor"></div>
                        <span className="ChiefDashbord_FeedHeaderTitle">داشبورد مدیر ارشد</span>
                    </div>

                    <div className="ChiefDashbord_FeedHeaderLogin">
                        <span className="ChiefDashbord_FeedHeaderLoginTitle1">وارد شده به عنوان</span>
                        <span className="ChiefDashbord_FeedHeaderLoginTitle2">مدیر ارشد</span>
                        <div className="ChiefDashbord_FeedHeaderLogout">
                            <span className="ChiefDashbord_FeedHeaderLogoutTitle">خروج</span>
                            <div className="ChiefDashbord_FeedHeaderLogoutIcon">
                                <BiLogOut />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ChiefDashbord_FeedContent">
                    <div className="ChiefDashbord_FeedContentEvaluationContainer" style={{ borderBottom: "none" }}>
                        <div className="ChiefDashbord_FeedContentEvaluationTitles">
                            <div className="ChiefDashbord_FeedContentEvaluationTitleContainer">
                                <div className="ChiefDashbord_FeedContentEvaluationTitleIcon">
                                    <RiSearch2Line />
                                </div>

                                <span className="ChiefDashbord_FeedContentEvaluationTitle">وبلاگ</span>
                            </div>
                            <span className="ChiefDashbord_FeedContentEvaluationTitleDescribe">مدیریت مطالب آموزشی وبلاگ</span>
                        </div>
                    </div>
                    <div className="ChiefDashbord_Feed_PostFiltersButton">
                        <div className="ChiefDashbord_Feed_PostFilters">
                            <span className={["ChiefDashbord_Feed_PostFilter", postFilter === 1 ? "ChiefDashbord_Feed_PostFilterActive" : ""].join(" ")} onClick={() => setPostFilter(1)}>
                                {" "}
                                همه
                            </span>
                            <span className={["ChiefDashbord_Feed_PostFilter", postFilter === 2 ? "ChiefDashbord_Feed_PostFilterActive" : ""].join(" ")} onClick={() => setPostFilter(2)}>
                                {" "}
                                مطالب آموزشی{" "}
                            </span>
                            <span className={["ChiefDashbord_Feed_PostFilter", postFilter === 3 ? "ChiefDashbord_Feed_PostFilterActive" : ""].join(" ")} onClick={() => setPostFilter(3)}>
                                {" "}
                                اخبار
                            </span>
                        </div>
                        <div className="ChiefDashbord_Feed_PostButton">
                            <span className="ChiefDashbord_Feed_PostButtonTitle"> مطلب جدید </span>
                            <div className="ChiefDashbord_FeedContentEvaluationButtonIcon">
                                <BsPlusSquare />
                            </div>
                        </div>
                    </div>
                    <div className="PostFilters2Container">
                        <div className="PostFilters2Top">
                            <DropDown2 optionsList={optionsList1} placeholder="همه دسته بندی ها" />
                            <div className="PostFilters2TopInputContainer">
                                <input className="PostFilters2TopInput" placeholder="جست و جو" />
                                <div className="PostFilters2TopInputIcon">
                                    <RiSearch2Line />
                                </div>
                            </div>
                        </div>
                        <div className="PostFilters2Down">
                            <CheckBox title="انتخاب همه " backColor="rgb(255, 255, 255)" />
                            <div className="PostFilters2DownRemoveContainer">
                                <div className="PostFilters2DownRemoveIcon">
                                    <BiTrash />
                                </div>
                                <span className="PostFilters2DownRemoveTitle">حذف </span>
                            </div>
                        </div>
                    </div>
                    {blogPosts.length !== 0 ? (
                        <div className="ChiefDashbord_FeedBuildings" style={{ marginBottom: "64px" }}>
                            <div className="ChiefDashbord_FeedBuildingstitles" style={{ display: "flex" }}>
                                <span className="ChiefDashbord_FeedBuildingstitle1" style={{ flexGrow: 1 }}>
                                    {" "}
                                    ردیف
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle2" style={{ flexGrow: 12, maxWidth: "40%", minWidth: "40%", padding: "12px" }}>
                                    عنوان
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle3" style={{ flexGrow: 2 }}>
                                    دسته ها
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle4" style={{ flexGrow: 2 }}>
                                    تاریخ انتشار
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle8" style={{ flexGrow: 2 }}>
                                    عملیات{" "}
                                </span>
                            </div>
                            {blogPosts.map(function (item, i) {
                                return <BlogBox data={item} index={i} />;
                            })}
                        </div>
                    ) : (
                        <div className="ChiefDashbord_FeedBuildings" style={{ marginBottom: "64px" }}>
                            <div className="ChiefDashbord_FeedBuildingstitles" style={{ display: "flex" }}>
                                <span className="ChiefDashbord_FeedBuildingstitle1" style={{ flexGrow: 1 }}>
                                    {" "}
                                    ردیف
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle2" style={{ flexGrow: 12, maxWidth: "40%", minWidth: "40%", padding: "12px" }}>
                                    عنوان
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle3" style={{ flexGrow: 4 }}>
                                    دسته ها
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle4" style={{ flexGrow: 4 }}>
                                    تاریخ انتشار
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle8" style={{ flexGrow: 4 }}>
                                    عملیات{" "}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Drawer className="Links_DrawerChiefBoard" anchor={"right"} open={DP_DrawerB} onClose={() => setDP_DrawerB(false)}>
                <div className="Links_DrawerChiefBoardContainer">
                    <ChiefDashbord_sidebar_res setDP_DrawerB={setDP_DrawerB} ChiefName="متین نوروزپور" path="" marginTop="0px" userProfile={ProfileImage} sidebar={2} />
                </div>
            </Drawer>
        </div>
    );
}

export default ChiefDashbord;
